const DATE_INPUT_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Last millisecond of the local calendar day for `endDateMs` (23:59:59.999). */
export function endOfLocalCalendarDay(endDateMs: number): number {
  const d = new Date(endDateMs);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999).getTime();
}

/** True if `nowMs` is after the end of the expiry calendar day (inclusive through that day). */
export function isCouponPastEndDate(nowMs: number, endDateMs: number | null | undefined): boolean {
  if (endDateMs == null || endDateMs === undefined) return false;
  return nowMs > endOfLocalCalendarDay(endDateMs);
}

/**
 * HTML `<input type="date">` value `YYYY-MM-DD` → end of that **local** calendar day.
 * Avoids `new Date('YYYY-MM-DD')` (UTC midnight) expiring coupons partway through the chosen day.
 */
export function localEndOfDayFromDateInput(dateStr: string): number {
  const trimmed = dateStr.trim();
  const m = DATE_INPUT_RE.exec(trimmed);
  if (!m) return new Date(trimmed).getTime();
  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const day = Number(m[3]);
  return new Date(y, mo, day, 23, 59, 59, 999).getTime();
}
